// Espera visível do "Reenviar" na AUTH-CONFIRME-EMAIL (ux §3.1 item 3).
// O Auth também limita o reenvio; a espera na tela evita cliques que só dariam erro.
export const RESEND_COOLDOWN_MS = 60_000;

/** Segundos inteiros que faltam para poder reenviar (0 = pode). */
export function resendWaitSeconds(lastSentAt: number, now: number, cooldownMs = RESEND_COOLDOWN_MS): number {
  return Math.max(0, Math.ceil((lastSentAt + cooldownMs - now) / 1000));
}
